import * as React from 'react'
import { IMobilityOptionCategoryObject, IMobilityOptionObject } from '../../types'
import MobilityItemDeviceAction from './MobilityDevicesItemAction'

interface IGlobalSettingsMobilityDevicesListItemProps {
  device: IMobilityOptionObject
  categories: IMobilityOptionCategoryObject[]
}

class MobilityDevicesListItem extends React.Component<IGlobalSettingsMobilityDevicesListItemProps> {
  public render() {
    const { device, ...props } = this.props
    return (
      <div className='flex justify-between pl3'>
        <div className='flex col-12'>
          <div className='col-3 text-overflow-break-word'>
            {this.props.categories[device.categoryId] ? this.props.categories[device.categoryId].name : ''}
          </div>
          <div className='col-3 text-overflow-break-word'>{device.name}</div>
          <div className='col-5 text-overflow-break-word'>{device.isTransferableSeat ? 'Yes' : 'No'}</div>
          <div className='col-1 flex justify-center'>
            <div>
              <MobilityItemDeviceAction id={device.id} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default MobilityDevicesListItem



// WEBPACK FOOTER //
// ./src/components/global-settings/MobilityDevicesListItem.tsx